/* global XMLHttpRequest */
'use strict';
/**
 * Given a url and a return type, returns a promise to the content of the url
 * Basically it wraps a XMLHttpRequest into a Promise
 *
 * @param {String} url
 * @param {String} type - can be 'text' or 'arraybuffer'
 * @return {Promise}
 */

module.exports = function (url, type) {
  return new Promise(function (done, reject) {
    var req = new XMLHttpRequest();
    if (type) req.responseType = type;
    req.open('GET', url);

    req.onload = function () {
      req.status === 200 ? done(req.response) : reject(Error(req.statusText));
    };

    req.onerror = function () {
      reject(Error('Network Error'));
    };

    req.send();
  });
};